import { render, staticRenderFns } from "./RelatorioOrdemServicoLegacy.vue?vue&type=template&id=2fc0b943"
import script from "./RelatorioOrdemServicoLegacy.vue?vue&type=script&lang=js"
export * from "./RelatorioOrdemServicoLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports